import declare from "dojo/_base/declare";
import NewSupplierRequest from "./NewSupplierRequest";

const NewFoodSupplierRequest = declare(NewSupplierRequest, {
	fixedType: "DataPackageContainerType:Food",
	productField: "Foods",
});

export = NewFoodSupplierRequest;